import React from 'react';

export const defaultContext = {};

export const CashierContext = React.createContext(defaultContext);
